import CONFIG from '../../../config';

const getNewChatProbability = (environment) => {
  const urlParams = new URLSearchParams(window.location.search);
  const newChatProbabilityFromUrl = parseInt(urlParams.get('new_chat_probability'));

  // @ts-ignore
  const newChatProbabilityFromConsole = Number(window.NEW_CHAT_PROBABILITY_PERCENTAGE);

  if (newChatProbabilityFromConsole === 0) {
    return newChatProbabilityFromConsole;
  }

  return !Number.isNaN(newChatProbabilityFromUrl)
    ? newChatProbabilityFromUrl
    : newChatProbabilityFromConsole || CONFIG.SALES_CHAT_CONFIGURATION_BY_SITE_ENV[environment].NEW_CHAT_PROBABILITY_PERCENTAGE;
};

const seededRandom = (seed) => {
  // distributes users connections random across all masters and workers
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const stringToNumericValue = (str) => {
  const stringValue = String(str);
  const stringToNumbers = stringValue
    .split('')
    .map((char) => char.charCodeAt(0))
    .join('')
    .slice(0, 255);

  return Number(stringToNumbers);
};

export const shouldOpenNewChat = ({ environment }) => {
  const newChatProbability = getNewChatProbability(environment);
  const seededValue = stringToNumericValue(window.navigator.userAgent);

  const randomPercentage = seededRandom(seededValue) * 100;

  return Boolean(
    randomPercentage < newChatProbability
  );
};
